<template>
    <div class="page-container">
        <div class="page-content">
            <div class="left-side-container">
                <div class="page-header">
                    <h1>{{ $t('Оповещения') }}</h1>
                </div>

                <div class="settings-container">
                    <div class="settings-block" id="email">
                        <div class="block-header">
                            <h3>Email</h3>
                        </div>
                        <div class="block-content">
                            <div class="col-12">
                                <p>{{ $t('Email на который будут отправлятся оповещения') }}: <strong v-text="user.email"></strong></p>
                                
                                <div class="notification-option-row" v-for="type in types" :key="type.key">
                                    <div class="checkbox-group mt-24 mb-5">
                                        <input :id="`email_${type.key}`" v-model="notifications.email[type.key]" type="checkbox">
                                        <label :for="`email_${type.key}`" class="checkbox-label">
                                            {{ $t(type.name) }}
                                        </label>
                                    </div>
                                    <p class="info-tip" v-html="$t(type.description)"></p>
                                </div>

                                <div class="text-center">
                                    <button class="btn btn-blue" @click.prevent="update">{{ $t('Сохранить') }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="settings-block" id="telegram">
                        <div class="block-header">
                            <h3>Telegram</h3>
                        </div>
                        <div class="block-content">
                            <div class="col-12" v-if="! telegram.connected">
                                <p>{{ $t('Оповещения в телеграм приходят через нашего бота') }} <a target="_blank" :href="`http://t.me/ufin_bot?start=${telegram.token}`">@ufin_bot</a>. {{ $t('Для того что бы привязать ваш телеграм аккаунт к нашему сервису, отправьте боту в чат ваш код') }}:</p>

                                <div class="form-group">
                                    <input type="text" disabled class="form-control" :value="telegram.token">
                                </div>

                                <p class="info-tip">{{ $t('Как только вы привяжите ваш аккаунт, вам станут доступны настройки оповещений для Telegram') }}</p>
                            </div>
                            <div class="col-12" v-else>
                                <p>{{ $t('Telegram на который будут отправлятся оповещения') }}: <strong>@{{ telegram.name }}</strong></p>
                            
                                <div class="notification-option-row" v-for="type in types" :key="type.key">
                                    <div class="checkbox-group mt-24 mb-5">
                                        <input :id="`telegram_${type.key}`" v-model="notifications.telegram[type.key]" type="checkbox">
                                        <label :for="`telegram_${type.key}`" class="checkbox-label">
                                            {{ $t(type.name) }}
                                        </label>
                                    </div>
                                    <p class="info-tip" v-html="$t(type.description)"></p>
                                </div>

                                <div class="text-center">
                                    <button class="btn btn-blue" @click.prevent="update">{{ $t('Сохранить') }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="right-side-container settings-right-side sticky">
                <RightSideUserControls />

                <div class="list-group">
                    <a href="#" @click.prevent="scrollTo('email')" class="list-group-item list-group-item-action"><i class="fas fa-envelope"></i> Email</a>
                    <a href="#" @click.prevent="scrollTo('telegram')" class="list-group-item list-group-item-action"><i class="fab fa-telegram"></i> Telegram</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import RightSideUserControls from "@/new/components/RightSideUserControls.vue";
import { EventBus } from '../../../../event-bus';

export default {
    name: "Notifications",

    components: {
        RightSideUserControls,
    },

    computed: {
        ...mapState(['user']),
    },

	data: function() {
        return {
            telegram: {
                connected: false,
                name: null,
                token: null,

                interval: null,
            },
            notifications: {
                email: {},
                telegram: {},
            },
            types: [
                {'name': 'Новые операции', 'description': 'new_operation_desc', 'key': 'new_operation'},
                // {'name': 'Регулярные платежи', 'key': 'regular_transaction'},
                // {'name': 'Напоминание', 'key': 'notifcation'},
                {'name': 'Статистика за день', 'description': 'day_statistic_desc', 'key': 'day_statistic'},
                {'name': 'Статистика за месяц', 'description': 'month_statistic_desc', 'key': 'month_statistic'},
                {'name': 'Доступный лимит на день', 'description': 'day_limit_desc', 'key': 'day_limit'},
                {'name': 'Напоминания', 'description': 'reminder_desc', 'key': 'reminder'},
            ],
        };
    },

    mounted() {
        this.checkTelegramStatus();  
        this.loadNotifications();
    },

    methods: {
        checkTelegramStatus(generateToken = true) {
            axios.get('/telegram/status')
                .then(({data}) => {
                    this.telegram.connected = data.data.connected;
                    this.telegram.name = data.data.name;

                    if(! this.telegram.connected && generateToken) {
                        this.generateTelegramToken();
                    }

                    if(this.telegram.connected) {
                        clearInterval(this.telegram.interval);
                    }
                }).catch(({response}) => {
                    console.log(response);
                    
                    return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');
                });
        },

        loadNotifications() {
            axios.get('/notifications')
                .then(({data}) => {
                    if(data.data.telegram.length !== 0) {
                        this.notifications.telegram = data.data.telegram;
                    }

                    if(data.data.email.length !== 0) {
                        this.notifications.email = data.data.email;
                    }
                }).catch(({response}) => {
                    console.log(response);
                    
                    return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Ошибка при загрузке данных'), 'error');
                });
        },
        
        update() {
            axios.post('/notifications/update', this.notifications)
                .then(({data}) => {
                    return EventBus.$emit('show-alert', data.message, 'success');
                }).catch(({response}) => {
                    console.log(response);
                    
                    return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');
                });
        },

        generateTelegramToken() {
            axios.post('/telegram/token')
                .then(({data}) => {
                    this.telegram.token = data.data.token;

                    this.telegram.interval = setInterval(() => this.checkTelegramStatus(false), 2000);
                }).catch(({response}) => {
                    console.log(response);
                    
                    return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');
                });
        },

        scrollTo(block) {
            const el = document.getElementById(block).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
        }
    },

    beforeDestroy() {
        clearInterval(this.telegram.interval);
    }
}
</script>

<style lang="scss">
.settings-right-side {
    @media (max-width: 768px) {
        display: none;
    }

    .list-group {
        display: flex;
        flex-direction: column;
        padding-left: 0;

        border-radius: 5px;
        background-color: #fff;
        box-shadow: 0 0 30px 0 rgba(0,0,0,.05);
        margin: 0 0;

        .list-group-item {
            position: relative;
            display: block;
            padding: 0.75rem 1.25rem;
            background-color: #fff;
            border-bottom: 1px solid #F0F1F7;
            color: #152640;

            &:first-child {
                border-top: none;
                border-top-left-radius: inherit;
                border-top-right-radius: inherit;
            }

            &:last-child {
                border-bottom: none;
                border-bottom-left-radius: inherit;
                border-bottom-right-radius: inherit;
            }

            &:hover {
                background: #f59c25;
                color: #fff;
            }

            &:first-child {
                border-top: none;
            }

            &:last-child {
                border-bottom: none;
            }
        }
    }
}

.settings-container {
    display: flex;
    flex-wrap: wrap;

    .settings-block {
        width: 100%;
        background: #fff;
        border-radius: 5px;
        margin-bottom: 24px;
        padding: 24px 32px;

        .block-header {
            h3 {
                font-size: 18px;
                font-family: 'Proxima Nova Lt';
                font-weight: 600;
                color: #152640;
                margin: 0;
                margin-bottom: 18px;
            }
        }

        .block-content {
            display: flex;
            width: 100%;
            flex-wrap: wrap;

            .form-group {
                width: 100%;
                display: flex;
                align-items: center;

                label {
                    width: 30%;
                }

                .form-control {
                    width: calc(70% - 24px);
                }
            }

            .btn-group {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 10px;

                &.btn-nav-group {
                    justify-content: start;

                    .btn {
                        border-radius: 0;
                        margin: 0;
                        display: flex;
                        align-items: center;

                        &:first-child {
                            border-top-left-radius: 5px;
                            border-bottom-left-radius: 5px;
                        }

                        &:last-child {
                            border-top-right-radius: 5px;
                            border-bottom-right-radius: 5px;
                        }
                    }
                }

                .btn {
                    width: auto;
                }
            }
        }
    }
}
</style>